module.exports = __webpack_public_path__ + "img/b1.2b352b3d.jpg";